import { Modal, Box, Typography, Button, Stack } from "@mui/material";

export default function ModalConfirmUniversal({
  open,
  onClose,
  title = "Confirmar acción",
  message = "¿Estás seguro?",
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  onConfirm,
  color = "error",
}) {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          width: 400,
          bgcolor: "#fff",
          p: 3,
          borderRadius: 3,
          mx: "auto",
          mt: "20vh",
          textAlign: "center",
          boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
          border: `2px solid ${color === "success" ? "#4caf50" : "#f44336"}`,
        }}
      >
        <Typography variant="h6" mb={2} sx={{ fontWeight: 700 }}>
          {title}
        </Typography>

        <Typography
          color="text.secondary"
          mb={3}
          sx={{
            whiteSpace: "pre-wrap",
            lineHeight: 1.6,
            fontSize: "0.95rem",
          }}
        >
          {message}
        </Typography>

        <Stack spacing={2}>
          <Button
            variant="contained"
            color={color}
            onClick={onConfirm}
            sx={{
              fontWeight: 700,
              py: 1.2,
              ...(color === "success" && {
                background: "linear-gradient(135deg, #4caf50 0%, #45a049 100%)",
                "&:hover": {
                  background: "linear-gradient(135deg, #45a049 0%, #388e3c 100%)",
                },
              }),
            }}
          >
            {confirmText}
          </Button>

          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              fontWeight: 600,
              py: 1,
              color: "#666",
              borderColor: "#ddd",
              "&:hover": {
                borderColor: "#999",
                bgcolor: "rgba(0,0,0,0.03)",
              },
            }}
          >
            {cancelText}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}
